// Author: Mohammad Arman Khan
import React, { Component } from 'react';
import Header from '../../layout/header/header'
import Footer from '../../layout/footer/footer'
import '../privacy-policy/privacyPolicy.css';

class privacyPolicy extends Component {
    render() {
        return (
            <div>
    <Header/>
                
        {/* <!-- term_condition start --> */}
    <div className="term_condition_bnr"></div>

    <div className="term_condition">
        <div className="container-fluid">
           <div className="term_condi_inr">
                <h2 className="text-center">Privacy Policy</h2>
                <h4>Overview</h4>
                <p>1. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor </p>
                <p>2. incididunt ut labore et dolore magna aliqua. eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                <p>3. labore et dolore mikm ipsum dolor sit amet, consectetur adipiscing elit, sed </p>
                <p>4. do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,</p>

                <h4>Consent and privacy</h4>
                <p>1. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor </p>
                <p>2. incididunt ut labore et dolore magna aliqua. eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                <p>3. labore et dolore mikm ipsum dolor sit amet, consectetur adipiscing elit, sed </p>
                <p>4. do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,</p>

                <h4>Consent and privacy</h4>
                <p>1. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor </p>
                <p>2. incididunt ut labore et dolore magna aliqua. eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                <p>3. labore et dolore mikm ipsum dolor sit amet, consectetur adipiscing elit, sed </p>
                <p>4. do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,</p>
 
           </div>
        </div>
    </div>
    <Footer/>

            </div>
        );
    }
}

export default privacyPolicy;
